import { render, staticRenderFns } from "./AvailableProjectDetailsModal.vue?vue&type=template&id=15404d84&scoped=true&"
import script from "./AvailableProjectDetailsModal.vue?vue&type=script&lang=js&"
export * from "./AvailableProjectDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./AvailableProjectDetailsModal.vue?vue&type=style&index=0&id=15404d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15404d84",
  null
  
)

export default component.exports